<div class="vflex-300">
  <h2>Date Pickers</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; DateTimePickerComponent &#125; from
      '&#64;spaces-ui/meadow/components/date-time';
    </code>
  </div>

  <h3>Date Time Picker</h3>
  <ng-template #datePicker data-sample="datePicker">
    <section class="vflex-300 flex-no-stretch">
      <mdw-date-time-picker
        [value]="value()"
        (valueChange)="value.set($event)"
      ></mdw-date-time-picker>

      <div class="hflex-100">
        <p class="bold">Date Value:</p>
        <p class="secondary">{{ value() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="datePicker" sampleName="datePicker"></app-sample>

  <h3>Date Time Picker Card (inline)</h3>
  <ng-template #cardInline data-sample="cardInline">
    <section class="vflex-300 flex-no-stretch">
      <mdw-date-time-picker-card
        [date]="inlineDate()"
        (dateChange)="inlineDate.set($event)"
        [time]="inlineTime()"
        (timeChange)="inlineTime.set($event)"
      ></mdw-date-time-picker-card>

      <div class="vflex-075">
        <div class="hflex-100">
          <p class="bold">Date:</p>
          <p class="secondary">{{ inlineDate() }}</p>
        </div>
        <div class="hflex-100">
          <p class="bold">Time:</p>
          <p class="secondary">{{ inlineTime() | json }}</p>
        </div>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="cardInline" sampleName="cardInline"></app-sample>

  <h3>Date Time Picker Card (inside cdkMenu)</h3>
  <ng-template #cardInMenu data-sample="cardInMenu">
    <section class="vflex-300 flex-no-stretch">
      <button
        #cardTrigger="cdkMenuTriggerFor"
        class="mdw-button mdw-secondary flex-no-stretch"
        [cdkMenuTriggerFor]="cardMenuTpl"
      >
        Open picker
      </button>

      <ng-template #cardMenuTpl>
        <menu
          class="surface-floating pad-100 border-radius-100"
          cdkMenu
          animate.enter="menu-enter"
          animate.leave="menu-leave"
        >
          <mdw-date-time-picker-card
            [date]="menuDate()"
            (dateChange)="menuDate.set($event)"
            [time]="menuTime()"
            (timeChange)="menuTime.set($event)"
            (sizeChanged)="repositionCdkMenuTrigger(cardTrigger)"
          ></mdw-date-time-picker-card>
        </menu>
      </ng-template>

      <div class="vflex-075">
        <div class="hflex-100">
          <p class="bold">Date:</p>
          <p class="secondary">{{ menuDate() }}</p>
        </div>
        <div class="hflex-100">
          <p class="bold">Time:</p>
          <p class="secondary">{{ menuTime() | json }}</p>
        </div>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="cardInMenu" sampleName="cardInMenu"></app-sample>
</div>
